import { useOnlineStatus } from "../hooks/useOnlineStatus";

export function OnlineStatus() {
  const isOnline = useOnlineStatus();

  return (
    <div className="flex items-center space-x-2">
      <div className={`h-2 w-2 rounded-full ${isOnline ? "bg-green-500" : "bg-red-500"}`} />
      <span className={`text-sm ${isOnline ? "text-green-600" : "text-red-600"}`}>
        {isOnline ? "Online" : "Offline"}
      </span>
    </div>
  );
}

export function OnlineIndicator() {
  const isOnline = useOnlineStatus();

  if (!isOnline) return null;

  return (
    <div className="fixed left-0 right-0 top-0 z-50 bg-green-600 px-4 py-2 text-center text-sm text-white">
      <div className="flex items-center justify-center space-x-2">
        <svg className="h-4 w-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
        </svg>
        <span>You're back online!</span>
      </div>
    </div>
  );
}

interface OnlineMessageProps {
  message?: string;
  className?: string;
}

export function OnlineMessage({ message = "You're connected to the internet.", className = "" }: OnlineMessageProps) {
  const isOnline = useOnlineStatus();

  if (!isOnline) return null;

  return (
    <div className={`rounded-lg border border-green-200 bg-green-50 p-4 ${className}`}>
      <div className="flex items-center">
        <svg className="mr-3 h-5 w-5 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
          />
        </svg>
        <p className="text-sm text-green-800">{message}</p>
      </div>
    </div>
  );
}

interface ConnectionStatusProps {
  showText?: boolean;
  className?: string;
}

export function ConnectionStatus({ showText = true, className = "" }: ConnectionStatusProps) {
  const isOnline = useOnlineStatus();

  return (
    <div className={`flex items-center space-x-2 ${className}`}>
      <div
        className={`h-3 w-3 rounded-full ${isOnline ? "bg-green-500" : "bg-red-500"}`}
        title={isOnline ? "Connected" : "Disconnected"}
      />
      {showText && (
        <span className={`text-sm font-medium ${isOnline ? "text-green-600" : "text-red-600"}`}>
          {isOnline ? "Connected" : "Disconnected"}
        </span>
      )}
    </div>
  );
}
